<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="12" sm="8">
				<v-card>
					<v-card-title class="grey darken-3 d-flex">
						<span class="headline white--text">{{ title }}</span>
						<v-btn v-if="permissions['9']" small @click="saveSettings" color="green darken-3" class="ml-auto">save
						</v-btn>
					</v-card-title>
					<static-list :save-marker="saveMarker" :data-list="dataSettings.setting" :title="'Mail:'"
					             :color="'teal darken-4'"/>
					<dynamic-list :save-marker="saveMarker" :data-list="dataSettings.maps" :key-value="'setting_value'"
					              :title="'Map KEYS:'" :color="'blue-grey darken-2'"/>
					<dynamic-list :save-marker="saveMarker" :data-list="dataSettings.trailer_type" :key-value="'name'"
					              :title="'Trailer Types:'" :color="'cyan darken-4'"/>
					<!-- Statistics -->
					<static-list :statistics-data="ds3" @set-statistic-data="setStatisticData" :save-marker="saveMarker"
					             :data-list="dataSettings.report_contacts" :dispatchers="dataSettings.dispatcher"
					             :title="'Statistics:'" :color="'teal darken-4'"/>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
import StaticList from "@/components/Settings/SettingsSystem/static-list/static-list.component";
import DynamicList from "@/components/Settings/SettingsSystem/dynamic-list/dynamic-list.component";

export default {
	name: "SettingsSystem",
	components: {
		StaticList,
		DynamicList
	},
	data() {
		return {
			title: "System Settings",
			saveMarker: false,
		};
	},
	computed: {
		permissions() {
			return this.$store.getters.permissions;
		},
		dataSettings() {
			return this.$store.getters.getSystemSettings;
		},
		ds3() {
			return this.$store.getters.getDataSettings;
		}
	},
	methods: {
		setStatisticData(value) {
			this.$store.dispatch('dstatisticDataSen', value);
		},
		async getData() {
			this.$store.dispatch("actionPreloader", true);
			await this.$store.dispatch("onFetchSystemSettings").then(() => {
				this.$store.dispatch("actionPreloader", false);
			});
		},
		async saveSettings() {
			this.saveMarker = false;
			this.$store.dispatch("actionPreloader", true);
			await this.$store.dispatch("onFetchSaveSettings", this.dataSettings).then(() => {
				this.$store.dispatch("actionPreloader", false);
				this.saveMarker = true;
			});
		}
	},
	mounted() {
		this.getData();
	},
	watch: {}
};
</script>
<style lang="scss" scoped>
@import "settingsSystem";
</style>
